import { Map } from 'immutable';
import actions from 'redux/constants/admin/institutions';

const defaultState = () => new Map({
  institutionItem: new Map(),
  institutionIsSubmitting: false,
  institutionCreateFailed: false,
  bindingsLoading: false,
  bindingsSubmitting: false,

  institutionsByLevel: new Map(),
  institutionsByLevelAreLoading: true,
  photo: undefined,

  institutionsByLevelExeptLast: new Map(),
  istitutionsByLevelExeptLastIsLoading: true,

  institutionParent: new Map(),
  loadParentByParentPropertyIsLoading: true,

  serviceInstitution: new Map(),
  personalInstitution: new Map(),

    typesForSub: new Map(),
    typesForSubAreLoading: true
})
 
export default (state = defaultState(), action) => {
  switch(action.type) {
    case actions.SET_INSTITUTION_ITEM:
      return state.set('institutionItem', action.data);
    case actions.SET_SERVICE_INSTITUTION_ITEM:
      return state.set('serviceInstitution', action.data);
    case actions.SET_PERSONAL_INSTITUTION_ITEM:
      return state.set('personalInstitution', action.data);

    case actions.SET_NEW_INSTITUTION_DETAIL:
      return state.set('newInstitutionItem', action.data);
    case actions.INSTITUTION_BINDINGS_LOADING:
      return state.set('bindingsLoading', action.data);
    case actions.ADMIN_INSTITUTION_SUBMITTING:
      return state.set('bindingsSubmitting', action.data);
    case actions.PERSONAL_INSTITUTION_PROCESS_FAILED:
      return state.set('personalInstitutionProcessFailed', action.data)
    case actions.SERVICE_INSTITUTION_PROCESS_FAILED:
      return state.set('serviceInstitutionProcessFailed', action.data)

    case actions.SET_INSTITUTION_PARENT:
      return state.set('institutionParent', action.data);
    case actions.PARENT_BY_PARENT_IS_LOADING:
      return state.set('loadParentByParentPropertyIsLoading', action.data);

    case actions.SET_INSTITUTION_ITEM_VALUE:
      return state.setIn(['institutionItem', action.key], action.data);
    case actions.INSTITUTION_IS_SUBMITTING:
      return state.set('institutionIsSubmitting', action.data);
    case actions.INSTITUTION_CREATE_FAILED:
      return state.set('institutionCreateFailed', action.data);

    case actions.LOAD_INSTITUTIONS_BY_LEVEL:
      return state.set('institutionsByLevel', action.data);
    case actions.INSTITUTIONS_BY_LEVEL_ARE_LOADING:
      return state.set('institutionsByLevelAreLoading', action.data);

    case actions.ATTACH_FILE:
      return state.setIn(['institutionItem', 'photo'], action.data);

    case actions.LOAD_INSTITUTIONS_BY_LEVEL_EXEPT_LAST:
      return state.set('institutionsByLevelExeptLast', action.data);
    case actions.INSTITUTIONS_BY_LEVEL_EXEPT_LAST_ARE_LOADING:
      return state.set('istitutionsByLevelExeptLastIsLoading', action.data);

        default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/admin/institutions.js